<button mat-button (click)="deleteTask()">Delete</button>